import { interaction } from "pixi.js";
import { Signal1 } from "@/js/util/event/Signal1";
import Disposable from "../util/disposable";

export default class Pointer implements Disposable {
  public down: Signal1<interaction.InteractionEvent>;
  public move: Signal1<interaction.InteractionEvent>;
  public up: Signal1<interaction.InteractionEvent>;

  constructor(manager: interaction.InteractionManager) {
    this.down = new Signal1();
    this.move = new Signal1();
    this.up = new Signal1();
    this._manager = manager;
    this._pointerDown = this.onpointerdown.bind(this);
    this._pointerUp = this.onpointerup.bind(this);
    this._pointerMove = this.onpointermove.bind(this);
    this._manager.addListener("pointerdown", this._pointerDown);
    this._manager.addListener("pointerup", this._pointerUp);
    this._manager.addListener("pointermove", this._pointerMove);
  }

  public dispose() {
    this._manager.removeListener("pointerdown", this._pointerDown);
    this._manager.removeListener("pointerup", this._pointerUp);
    this._manager.removeListener("pointermove", this._pointerMove);
  }

  private onpointerdown() {
    this.down.emit(this._manager.eventData);
  }

  private onpointerup() {
    this.up.emit(this._manager.eventData);
  }

  private onpointermove() {
    this.move.emit(this._manager.eventData);
  }

  private _manager: interaction.InteractionManager;
  private _pointerDown: () => void;
  private _pointerUp: () => void;
  private _pointerMove: () => void;
}
